// app/javascript/controllers/receipts_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customerSelect", "locationSelect", "contactSelect", "transactionSelect"]

  connect() {
    if (this.customerSelectTarget.value) {
      this.loadDependentData()
    }
  }

  loadDependentData() {
    const customerId = this.customerSelectTarget.value
    if (!customerId) return

    fetch(`/receipts/dependent_data?customer_id=${customerId}`)
      .then(response => response.json())
      .then(data => {
        this.fillSelect(this.locationSelectTarget, data.locations, this.locationSelectTarget.dataset.selected)
        this.fillSelect(this.contactSelectTarget, data.contacts, this.contactSelectTarget.dataset.selected)
        this.fillSelect(this.transactionSelectTarget, data.transactions, this.transactionSelectTarget.dataset.selected)
      })
  }

  fillSelect(select, options, selectedId) {
    select.innerHTML = ""

    options.forEach(opt => {
      const option = document.createElement("option")
      option.value = opt.id
      option.textContent = opt.name
      if (selectedId && selectedId == opt.id.toString()) {
        option.selected = true
      }
      select.appendChild(option)
    })
  }
}